import React from 'react';
import '../styles/Update.scss';
import View from '../components/View';
import MyAccountHeader from '../components/MyAccountHeader';
import Warning from './../assets/svgs/danger-sign.svg';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import AccountNav from '../components/AccountNav';

const UpdateAccount = () => {
  return (
    <View>
      <div className="grey-container pt-5">
        <div className="container pb-5">
          <MyAccountHeader />
          <div className="row">
            <div className="col-lg-3">
            <AccountNav />
            </div>
            <div className="col-lg-9">
              <p className="font-bold">Account Information</p>
              <div className="row">
                <div className="myaccount__content__body__popup">
                  <div className="myaccount__content__body__popup__warning">
                    <img src={Warning} alt="warning-sign" />
                  </div>
                  <div className="myaccount__content__body__popup__text">
                    <p>
                      If you wish to cancel or amend an order please{' '}
                      <Link to="/" className="text-orange">
                        contact customer services.
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="row pt-5 info-section">
                <div className="col-lg-6">
                  <h4 className="font-bold pb-5">Business Details</h4>
                  <p className="font-bold pb-2">Business Name</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <p className="font-bold pb-2">Company No.</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <p className="font-bold pb-2">Contact No.</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <p className="font-bold pb-2">Registered Address</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input type="text" className="form-control update-info" id="cardNumber" />
                </div>
                <div className="col-lg-6">
                  <h4 className="font-bold pb-5">Contact Information</h4>
                  <div className="row">
                    <div className="col-6">
                      <p className="font-bold pb-2">First Name</p>
                      <input
                        type="text"
                        className="form-control mb-3 update-info"
                        id="cardNumber"
                      />
                    </div>
                    <div className="col-6">
                      <p className="font-bold pb-2">Last Name</p>
                      <input
                        type="text"
                        className="form-control mb-3 update-info"
                        id="cardNumber"
                      />
                    </div>
                  </div>
                  <p className="font-bold pb-2">Email</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <p className="font-bold pb-2">Contact No.</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <p className="font-bold pb-2">Address</p>
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                  <input
                    type="text"
                    className="form-control mb-3 update-info"
                    id="cardNumber"
                  />
                </div>
              </div>
              <p className="text-grey-tiny pb-4">
                To make changes or update your account information please
                contact us
              </p>
              <Button text={'Request Update'} />
            </div>
          </div>
        </div>
      </div>
    </View>
  );
};

export default UpdateAccount;
